
    <div class="top-header">
        <div class="topbar flex ">
            <div class="col-6 flex">
                <img style="height:42px;margin: 0px 10px" src="assets/images/logo1.png">
                <div style="margin-top: 11px;">
                    <div *ngIf="locale!='en'" class="language" (click)="changLanguage('en')">EN</div>
                    <div *ngIf="locale!='de'"  class="language"  (click)="changLanguage('de')">DE</div>
                </div>
            </div>
            <div class="top-menu  ">
                <p-menubar [model]="menuItem"></p-menubar>
            </div>
        </div>
    </div>

    <div class="landing-body ">
        <section class="topSection  col-12 text-center">
            <div class="  flex flex-column align-items-center   "
                 style="padding: 0px 7%;">
                <h1 >Cloud search platform</h1>
                <h2 >Easier, faster and more accurate search for websites and applications</h2>
                <a href="#about"
                   class="opacity-100 flex align-items-center  border-round bg-primary p-3 m-3 font-bold"
                   >Get
                    Started</a>
                <img data-aos="zoom-in-up" data-aos-duration="2000" style="width: 100%"
                     src="assets/images/p1.jpg">
            </div>
        </section>
        <div class="main  col-12">
            <section class="main-s-1  ">
                <p data-aos="zoom-in-up" data-aos-duration="2000" >
                    Suchland’s mission is to enhance the way people find and discover information by providing a
                    cutting-edge
                    platform that combines powerful search capabilities, intelligent analytics, and actionable insights.
                    We
                    aim
                    to empower individuals and businesses with the tools they need to navigate the vast digital
                    landscape
                    effectively, identify user needs and preferences, and drive content enhancements to improve user
                    satisfaction.
                </p>
            </section>
            <div class="main-s-2  ">
                <h2 class=" col-12 text-center" >Services and Solutions</h2>
                <div class="row-sec inline-flex flex-wrap">
                    <div class="col-12 md:col-6" data-aos="fade-right" data-aos-duration="2000">
                        <img src="assets/images/search1.jpg" style="width: 100%">
                    </div>
                    <div class="col-12  md:col-6" data-aos="fade-left" data-aos-duration="2000" >
                        Advanced Search Capabilities: Suchland's platform offers advanced search capabilities that
                        enable
                        businesses to understand user queries and identify new and favorite topics. By analyzing user
                        search
                        patterns and queries, our platform provides valuable insights into user interests, helping
                        businesses
                        uncover emerging trends and areas of interest.
                    </div>
                </div>

                <div class="row-sec inline-flex flex-wrap md:flex-row-reverse">
                    <div class="col-6  " data-aos="fade-left" data-aos-duration="2000">
                        <img src="assets/images/analytic.png" style="width: 100%;">
                    </div>
                    <div class="col-12 md:col-6 " data-aos="fade-right" data-aos-duration="2000" >
                        User Query Analysis: Suchland's platform employs machine learning and AI algorithms to analyze
                        user
                        queries and identify patterns, preferences, and needs. By understanding the intent behind user
                        queries,
                        businesses can gain insights into what users are searching for and the content they are seeking.
                    </div>

                </div>

                <div class="row-sec  inline-flex flex-wrap">
                    <div class="col-12 md:col-6 " data-aos="fade-right" data-aos-duration="2000">
                        <img src="assets/images/content-creation-and-enhancement.jpg" style="width: 100%;height: 100%;">
                    </div>
                    <div class="col-12 md:col-6" data-aos="fade-left" data-aos-duration="2000" >
                        Content Enhancement and Development: Leveraging the insights from user query analysis,
                        businesses
                        can
                        use Suchland's platform to increase content in specific fields that align with user interests
                        and
                        needs.
                        For example, in a store business, this could involve introducing new products or expanding
                        product
                        varieties to cater to user preferences and improve user satisfaction.
                    </div>
                </div>

                <div class="row-sec inline-flex flex-wrap md:flex-row-reverse">
                    <div class="col-12 md:col-6" data-aos="fade-left" data-aos-duration="2000">
                        <img src="assets/images/Data-Driven-Decision-Making.png" style="width: 100%;">
                    </div>
                    <div class="col-12 md:col-6" data-aos="fade-right" data-aos-duration="2000" >
                        Data-Driven Decision Making: Suchland's platform provides businesses with data-driven insights
                        and
                        recommendations to drive content enhancements. By utilizing the information generated from user
                        query
                        analysis, businesses can make informed decisions regarding content development strategies,
                        product
                        offerings, and improvements to meet user needs effectively.
                    </div>

                </div>
            </div>
            <section class="main-s-3  " data-aos="fade-up" data-aos-duration="2000">
                <h2 class="text-center" >Commitment to Privacy and Security</h2>
                <p >
                    Suchland is committed to maintaining the privacy and security of user data. We adhere to stringent
                    data
                    protection practices, ensuring that user information is handled with utmost confidentiality. We are
                    fully compliant with applicable data protection regulations, giving our clients and users peace of
                    mind
                    regarding the privacy and security of their data.
                </p>
            </section>
            <section class="main-s-2  " data-aos="fade-up" data-aos-duration="2000">
                <h2 class="text-center" > Customer Success and Support </h2>
                <p >
                    At Suchland, we prioritize customer success and satisfaction. Our dedicated support team is readily
                    available to assist clients with any inquiries, technical issues, or questions related to user query
                    analysis, content enhancement, and data-driven decision making. We provide comprehensive
                    documentation,
                    tutorials, and resources to empower our clients to make the most of our platform's features and
                    optimize
                    their content strategies.
                </p>
            </section>
            <section class="main-s-3  " data-aos="fade-up" data-aos-duration="2000">
                <h2 class="text-center" >Join the Search Revolution with Suchland</h2>
                <p >
                    Experience the future of search and data-driven content enhancement with Suchland's advanced
                    platform.
                    Our comprehensive solution combines powerful search capabilities, intelligent analytics, and
                    actionable
                    insights to assist businesses in identifying new and favorite topics and needs of their users. With
                    our
                    state-of-the-art machine learning and AI technologies, we are transforming the way businesses
                    understand
                    user preferences and make content enhancements to improve user satisfaction.
                    Connect with us today to unlock the full potential of Suchland's platform and leverage user query
                    analysis to drive content enhancements and meet the evolving needs of your users in your store
                    business.
                </p>
            </section>

        </div>
    </div>
    <footer>
        <div class="footer-top">
            <div class="container">
                <div class="  " style="display:flex;flex-wrap:wrap;width: 100%;">
                    <div class="col-12 lg:col-4 md:col-6 footer-contact">
                        <img style="height:42px;margin: 0px 10px" src="assets/images/logo1.png">
                        <p>
                            Dresdner straße 7e,<br> 04103 Leipzig,<br> Deutschland/Germany<br>
                            <strong i18n="@@Phone">Phone:</strong>+491628966837<br>
                            <strong i18n="@@Email">Email:</strong>info&#64;suchlandco.de<br>
                        </p>
                    </div>

                    <div class="col-12 lg:col-3 md:col-6 footer-links">
                        <h4 i18n="@@Useful Links">Useful Links</h4>
                        <ul style="padding: 0px;">
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Home</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >About us</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Services</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Terms of service</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Privacy policy</a></li>
                        </ul>
                    </div>

                    <div class="col-12 lg:col-3 md:col-6  footer-links">
                        <h4 i18n="@@Our Services">Our Services</h4>
                        <ul style="padding: 0px;">
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Web Design</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Web Development</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Product Management</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Marketing</a></li>
                            <li><i class="pi pi-chevron-right"></i> <a href="#" >Graphic Design</a></li>
                        </ul>
                    </div>

                    <div class="col-12 lg:col-2 md:col-6 flex ">


                    </div>

                </div>
            </div>
        </div>
        <div class=" col-12  ">
            <div class=" text-center">
                <div class="inline-flex">
                    <div style="margin: 5px">
                        <a href="https://www.instagram.com/searchia_official/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 20 20"
                                 fill="none">
                                <path
                                        d="M6.58594 0.6875C3.41913 0.6875 0.835938 3.27069 0.835938 6.4375V13.9375C0.835938 17.1039 3.41904 19.6875 6.58594 19.6875H14.0859C17.2524 19.6875 19.8359 17.104 19.8359 13.9375V6.4375C19.8359 3.2706 17.2523 0.6875 14.0859 0.6875H6.58594ZM6.58594 2.1875H14.0859C16.4416 2.1875 18.3359 4.0814 18.3359 6.4375V13.9375C18.3359 16.293 16.4415 18.1875 14.0859 18.1875H6.58594C4.22983 18.1875 2.33594 16.2931 2.33594 13.9375V6.4375C2.33594 4.08131 4.22974 2.1875 6.58594 2.1875ZM15.3359 4.1875C14.7834 4.1875 14.3359 4.635 14.3359 5.1875C14.3359 5.74 14.7834 6.1875 15.3359 6.1875C15.8884 6.1875 16.3359 5.74 16.3359 5.1875C16.3359 4.635 15.8884 4.1875 15.3359 4.1875ZM10.3359 5.1875C7.58353 5.1875 5.33594 7.43509 5.33594 10.1875C5.33594 12.9399 7.58353 15.1875 10.3359 15.1875C13.0883 15.1875 15.3359 12.9399 15.3359 10.1875C15.3359 7.43509 13.0883 5.1875 10.3359 5.1875ZM10.3359 6.6875C12.2775 6.6875 13.8359 8.24591 13.8359 10.1875C13.8359 12.1291 12.2775 13.6875 10.3359 13.6875C8.39435 13.6875 6.83594 12.1291 6.83594 10.1875C6.83594 8.24591 8.39435 6.6875 10.3359 6.6875Z"
                                        fill="#2d405f" fill-opacity="0.95"></path>
                            </svg>
                        </a>
                    </div>

                    <div style="margin: 5px">
                        <a href="https://www.linkedin.com/company/searchia-saas">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
                                 fill="none">
                                <path
                                        d="M3.08594 0.1875C1.57605 0.1875 0.335938 1.42761 0.335938 2.9375V15.4375C0.335938 16.9474 1.57605 18.1875 3.08594 18.1875H15.5859C17.0958 18.1875 18.3359 16.9474 18.3359 15.4375V2.9375C18.3359 1.42761 17.0958 0.1875 15.5859 0.1875H3.08594ZM3.08594 1.6875H15.5859C16.2851 1.6875 16.8359 2.23839 16.8359 2.9375V15.4375C16.8359 16.1366 16.2851 16.6875 15.5859 16.6875H3.08594C2.38682 16.6875 1.83594 16.1366 1.83594 15.4375V2.9375C1.83594 2.23839 2.38682 1.6875 3.08594 1.6875ZM5.08594 3.6875C4.75442 3.6875 4.43647 3.8192 4.20205 4.05362C3.96763 4.28804 3.83594 4.60598 3.83594 4.9375C3.83594 5.26902 3.96763 5.58696 4.20205 5.82138C4.43647 6.0558 4.75442 6.1875 5.08594 6.1875C5.41746 6.1875 5.7354 6.0558 5.96982 5.82138C6.20424 5.58696 6.33594 5.26902 6.33594 4.9375C6.33594 4.60598 6.20424 4.28804 5.96982 4.05362C5.7354 3.8192 5.41746 3.6875 5.08594 3.6875ZM4.33594 7.1875C4.05944 7.1875 3.83594 7.411 3.83594 7.6875V14.1875C3.83594 14.464 4.05944 14.6875 4.33594 14.6875H5.83594C6.11244 14.6875 6.33594 14.464 6.33594 14.1875V7.6875C6.33594 7.411 6.11244 7.1875 5.83594 7.1875H4.33594ZM7.83594 7.1875C7.55944 7.1875 7.33594 7.411 7.33594 7.6875V14.1875C7.33594 14.464 7.55944 14.6875 7.83594 14.6875H9.33594C9.61244 14.6875 9.83594 14.464 9.83594 14.1875V10.4375C9.83594 9.748 10.3964 9.1875 11.0859 9.1875C11.7754 9.1875 12.3359 9.748 12.3359 10.4375V14.1875C12.3359 14.464 12.5594 14.6875 12.8359 14.6875H14.3359C14.6124 14.6875 14.8359 14.464 14.8359 14.1875V10.1875C14.8359 8.533 13.4904 7.1875 11.8359 7.1875C11.0669 7.1875 10.3674 7.48051 9.83594 7.95801V7.6875C9.83594 7.411 9.61244 7.1875 9.33594 7.1875H7.83594Z"
                                        fill="#2d405f" fill-opacity="0.95"></path>
                            </svg>
                        </a>
                    </div>

                    <div style="margin: 5px;">
                        <a href="mailto:info@suchlandco.de">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 17"
                                 fill="none">
                                <path
                                        d="M3.58594 0.1875C1.79997 0.1875 0.335938 1.65153 0.335938 3.4375V12.9375C0.335938 14.7235 1.79997 16.1875 3.58594 16.1875H17.0859C18.8719 16.1875 20.3359 14.7235 20.3359 12.9375V3.4375C20.3359 1.65153 18.8719 0.1875 17.0859 0.1875H3.58594ZM3.58594 1.6875H17.0859C18.061 1.6875 18.8359 2.46247 18.8359 3.4375V3.99023L10.3359 8.58496L1.83594 3.99023V3.4375C1.83594 2.46247 2.61091 1.6875 3.58594 1.6875ZM1.83594 5.69531L9.97949 10.0977C10.089 10.1568 10.2115 10.1878 10.3359 10.1878C10.4604 10.1878 10.5829 10.1568 10.6924 10.0977L18.8359 5.69531V12.9375C18.8359 13.9125 18.061 14.6875 17.0859 14.6875H3.58594C2.61091 14.6875 1.83594 13.9125 1.83594 12.9375V5.69531Z"
                                        fill="#2d405f" fill-opacity="0.95"></path>
                            </svg>
                        </a>
                    </div>
                </div>

            </div>


        </div>
    </footer>
